export default __webpack_public_path__ + "static/media/Diamond_Edge_large_5.d025df44.jpg";